export default __webpack_public_path__ + "33fad0273182d4d4b316f3a6e99955a9.png";